export default __webpack_public_path__ + "static/media/Loader-Gif.878cd9ee.gif";